import type { CSSPropertiesWithMultiValues } from "@emotion/serialize";
import type { CSSProperties } from "react";
import { mineShaft, white } from "../palette";
import type { ITooltipProps } from "./Tooltip";
import Tooltip from "./Tooltip";

interface ITextTooltipProps extends Omit<ITooltipProps, "render"> {
  content: string | (() => string);
  className?: string;
  contentClassName?: string;
  style?: CSSProperties;
  css?: CSSPropertiesWithMultiValues;
}

export default function TextTooltip({ content, contentClassName, className, style, css, ...props }: ITextTooltipProps) {
  return (
    <Tooltip
      {...props}
      backgroundColor={mineShaft}
      arrowColor={mineShaft}
      render={() => (
        <div
          className={className || contentClassName}
          css={{
            display: "flex",
            padding: "4px 8px",
            color: white,
            fontWeight: 500,
            fontSize: 13,
            lineHeight: 1.33,
            letterSpacing: 0.8,
            ...css,
          }}
          style={style}
        >
          {typeof content === "string" ? content : content()}
        </div>
      )}
    />
  );
}
